export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/e4LTGLZu4ybcfcFjyZHGNS/IMG_2619.jpg',
    alt: 'Volume 01 cover: Industry Fundamentals & Strategic Resources, a visual technical reference to lithium chemistry, critical mineral resources and global supply chains',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qrL4QXUjZmk1JEaK5wVTRb/IMG_2620.jpg',
    alt: 'Sample page: One Industry, Multiple Connected Value Chains, from geological resources to end-use technologies and mineral families',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3KyRSpPDMFSfwjA44b5LNu/IMG_2621.jpg',
    alt: 'Sample page: Where Does Lithium Occur? Lithium minerals and ore types including spodumene, petalite, lepidolite and lithium-bearing clays',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7JE1G5HotpdnQr1EuuSpCV/IMG_2622.jpg',
    alt: 'Sample page: Beyond Pegmatites and Salars, comparing clay, geothermal and oilfield lithium resources',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/aXbfdirShsatDW7KrWcAeq/IMG_2623.jpg',
    alt: 'Sample page: Copper as the electrical infrastructure foundation, from copper ore to electrical manufacturing',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/uMUhskNz2GDWsbP6y2vTS9/IMG_2624.jpg',
    alt: 'Sample page: From Spodumene-Bearing Ore to Refined Lithium, the hard-rock lithium value chain',
  },
];
